import { configureStore } from "@reduxjs/toolkit";
import { attachSentryIdentitySync } from "../helpers/logException/identitySync";
import { persistStore } from "redux-persist";
import { useDispatch } from "react-redux";
import type { ThunkDispatch } from "redux-thunk";
import type { AnyAction } from "@reduxjs/toolkit";

import rootReducer from "./rootReducer";
import type { RootState } from "./rootReducer";

export const store = configureStore({ reducer: rootReducer });

// Guarded: this module is evaluated during the Gatsby SSR build, where the
// browser Sentry SDK must not be called.
if (typeof window !== "undefined") {
  attachSentryIdentitySync(store);
}

export const persistor = persistStore(store);

// Typed dispatch that supports async thunks
export type AppDispatch = ThunkDispatch<RootState, unknown, AnyAction>;
export const useAppDispatch = () => useDispatch<AppDispatch>();

export default { store, persistor };
